import toolsClient from "@/api/toolsClient"
import { MULTIPART_HEADERS, buildEpisodeFormData } from "@/api/apiUtils"

export const getEpisodes = async (podcastKey, { limit = 10, search = "", offset = 0, order = "-publish_date" }) => {
  const response = await toolsClient.get(`/podcasts/${podcastKey}/episodes`, {
    params: { limit, offset, order, search: search || null },
  })

  return response.data
}

export const getEpisode = async (podcastKey, episodeKey) => {
  const response = await toolsClient.get(`/podcasts/${podcastKey}/episodes/${episodeKey}`)

  return response.data
}

export const createEpisode = async (podcastKey, episode) => {
  const response = await toolsClient.post(
    `/podcasts/${podcastKey}/episodes`,
    buildEpisodeFormData(episode),
    MULTIPART_HEADERS
  )

  return response.data
}

export const updateEpisode = async (episode) => {
  const response = await toolsClient.put(
    `/podcasts/${episode.podcast}/episodes/${episode.key}`,
    buildEpisodeFormData(episode),
    MULTIPART_HEADERS
  )

  return response.data
}

export const deleteEpisode = async (podcastKey, episodeKey) => {
  await toolsClient.delete(`/podcasts/${podcastKey}/episodes/${episodeKey}`)
}

export const deleteEpisodes = async (podcastKey, episodeKeys) => {
  await toolsClient.post(`/podcasts/${podcastKey}/episodes/bulk-delete`, episodeKeys)
}

export const uploadNewEpisodeFile = async (podcastKey, file, config) => {
  const data = new FormData()

  data.append("name", file.name)
  data.append("file", file)

  const response = await toolsClient.post(`/podcasts/upload/${podcastKey}`, data, {
    ...config,
    ...MULTIPART_HEADERS,
  })

  return response.data
}

export const uploadEpisodeFile = async (podcastKey, episodeKey, file, config) => {
  const data = new FormData()

  data.append("name", file.name)
  data.append("file", file)

  const response = await toolsClient.post(`/podcasts/upload/${podcastKey}/${episodeKey}`, data, {
    ...config,
    ...MULTIPART_HEADERS,
  })

  return response.data
}

export const getEpisodeUploadingStatus = async (taskId) => {
  const response = await toolsClient.get(`/podcasts/upload/task/${taskId}`)

  return response.data
}
